import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Projects } from "../components/Projects";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Socials } from "../components/Socials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#F7F7F5] font-body text-[#1A1A1A]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Projects />
        <About />
        <Services />
        <Socials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
